'use strict';

Object.defineProperty(exports, "__esModule", { value: true });
exports.getPageContent = void 0;
function getPageContent(page) {
    if (!page) {
        return '';
    }
    return typeof page === 'string' ? page : page.content;
}
exports.getPageContent = getPageContent;
